/*
 * File: /src/services/unitService.js
 * Created Date: Saturday April 8th 2023
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 8th April 2023 7:11:06 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2023 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_UNITS_PATH } from '../constants';

export default {
  fetchResUnitList() {
    return authedAxios.get(AD_BASE_UNITS_PATH + 'res-unit-list');
  },

  // Used for guidebooks, and anything else.
  fetchUnits(after, filters, tags, groups, sort, limit) {
    return authedAxios.get(AD_BASE_UNITS_PATH, {
      params: {
        filter: filters,
        tags: tags,
        groups: groups,
        limit: limit,
        sort: sort,
        after: after,
      },
    });
  },

  // Used for owner system
  fetchUnitsWithContacts(after, filters, tags, groups, sort, limit) {
    return authedAxios.get(`${AD_BASE_UNITS_PATH}units-with-contacts`, {
      params: {
        filter: filters,
        tags: tags,
        groups: groups,
        limit: limit,
        sort: sort,
        after: after,
      },
    });
  },

  fetchUnit(id) {
    return authedAxios.get(AD_BASE_UNITS_PATH + id);
  },

  createUnit(id, unitModel) {
    return authedAxios.post(AD_BASE_UNITS_PATH + id, unitModel);
  },

  patchUnit(id, unitModel) {
    return authedAxios.patch(AD_BASE_UNITS_PATH + id, unitModel);
  },

  deleteUnit(id) {
    return authedAxios.delete(AD_BASE_UNITS_PATH + id);
  },

  generateDescription(id) {
    return authedAxios.get(AD_BASE_UNITS_PATH + 'generate-description/' + id);
  },

  updateAdditional(id, payload) {
    return authedAxios.post(AD_BASE_UNITS_PATH + id + '/additional', payload);
  },
};
